import { Refresh } from '@mui/icons-material';
import {
  Box,
  Button,
  TextField,
  Typography,
  SxProps,
  Theme,
} from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import { ArticleEditAction, actions } from '../../reducer';
import { SLUG_LABEL } from '../constants';
import { validateSlug } from '../../../../utils/slugValidation';
import { generateSlugFromTitle } from '../../../../utils/slugGeneration';

interface SlugInputProps {
  dispatch: React.Dispatch<ArticleEditAction>;
  slug?: string | null;
  title?: string | null;
  sx?: SxProps<Theme>;
}

export const SlugInput: React.FC<SlugInputProps> = ({
  dispatch,
  slug,
  title,
  sx,
}) => {
  const [error, setError] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.toLowerCase(); // Convert to lowercase to match backend validation
    const validationError = validateSlug(value);
    setError(validationError);

    dispatch(
      actions.updateField({
        field: 'slug',
        value,
      }),
    );
  };

  const handleRegenerateSlug = () => {
    if (!title) {
      console.error('Title is required to generate slug');
      return;
    }

    const newSlug = generateSlugFromTitle(title);
    const validationError = validateSlug(newSlug);
    setError(validationError);

    dispatch(
      actions.updateField({
        field: 'slug',
        value: newSlug,
      }),
    );
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {SLUG_LABEL}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Button
            onClick={handleRegenerateSlug}
            disabled={!title}
            size="small"
            sx={{
              minWidth: 'auto',
              padding: '1.5px',
              backgroundColor: '#F44336',
              color: 'white',
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
              '&:disabled': {
                backgroundColor: 'action.disabled',
                color: 'action.disabled',
              },
            }}
          >
            <Refresh sx={{ fontSize: '14px' }} />
          </Button>
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.65rem',
              color: '#F44336',
            }}
          >
            Regénérer sur la base du titre
          </Typography>
        </Box>
      </Box>
      <TextField
        InputLabelProps={{
          shrink: true,
        }}
        label=""
        multiline
        fullWidth
        onChange={handleChange}
        value={slug || ''}
        variant="standard"
        error={!!error}
        helperText={error}
        sx={sx}
      />
    </Box>
  );
};
